// react
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { AppBar, useMediaQuery, useTheme } from '@mui/material';

import Footer from 'layout/BridgeLayout/Footer';

// components
import Header from 'layout/BridgeLayout/Header';
import AspTags from 'asp/bridge';

const MainLayout = () => {
  const theme = useTheme();
  const isPc = useMediaQuery(theme.breakpoints.up('sm'));
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <AppBar position={isPc ? 'fixed' : 'static'}>
        <Header />
      </AppBar>
      <Outlet />
      <Footer />
      <AspTags />
    </Suspense>
  );
};

export default MainLayout;
